import { useDecision } from '@optimizely/react-sdk';
import { FeatureFlag } from './featureFlags';
import { DEFAULT_SPLIT_VARIATION, VariationTypes } from './variationTypes';

export function useFeatureFlag(
  featureFlag: FeatureFlag & { variationType: typeof VariationTypes.ROLLOUT },
): { enabled: boolean } | null;
export function useFeatureFlag(
  featureFlag: FeatureFlag & { variationType: typeof VariationTypes.A_B_TESTING },
): { variation: (typeof VariationTypes.A_B_TESTING)[number] } | null;
export function useFeatureFlag(
  featureFlag: FeatureFlag & { variationType: typeof VariationTypes.OPT_IN_OUT },
): { variation: (typeof VariationTypes.OPT_IN_OUT)[number] } | null;

export function useFeatureFlag(featureFlag: FeatureFlag) {
  const [decision, clientReady] = useDecision(featureFlag.name, { autoUpdate: true });

  if (!clientReady) {
    return null;
  }

  if (featureFlag.variationType === VariationTypes.ROLLOUT) {
    return { enabled: decision.variationKey === 'on' };
  }

  /**
   * this is a one off feature flag for opt in/out orders redesign
   * this can be removed once the feature is fully rolled out
   */
  if (featureFlag.variationType === VariationTypes.OPT_IN_OUT) {
    // if decision.variationKey === off, then we should expect this flag to be fully rolled out
    return { variation: decision.variationKey === 'off' ? 'initialOptIn' : decision.variationKey };
  }

  const variation =
    decision.variationKey === 'off' ? DEFAULT_SPLIT_VARIATION : decision.variationKey;

  return { variation };
}
